import { lazyComponent } from '@/utils/lazyComponent'

export const BoardList = lazyComponent(() => import('./BoardListPage'))
export const BoardDetail = lazyComponent(() => import('./BoardDetailPage'))
export const BoardForm = lazyComponent(() => import('./BoardFormPage'))
